export const uttarakhandDistrictMap = {
  almora: {
    id: "1",
    value: "Almora",
    label: "Almora",
    hi: "अल्मोड़ा",
    name: "Almora",
  },
  bageshwar: {
    id: "2",
    value: "Bageshwar",
    label: "Bageshwar",
    hi: "बागेश्वर",
    name: "Bageshwar",
  },
  chamoli: {
    id: "3",
    value: "Chamoli",
    label: "Chamoli",
    hi: "चमोली",
    name: "Chamoli",
  },
  champawat: {
    id: "4",
    value: "Champawat",
    label: "Champawat",
    hi: "चम्पावत",
    name: "Champawat",
  },
  dehradun: {
    id: "5",
    value: "Dehradun",
    label: "Dehradun",
    hi: "देहरादून",
    name: "Dehradun",
  },
  haridwar: {
    id: "6",
    value: "Haridwar",
    label: "Haridwar",
    hi: "हरिद्वार",
    name: "Haridwar",
  },
  nainital: {
    id: "7",
    value: "Nainital",
    label: "Nainital",
    hi: "नैनीताल",
    name: "Nainital",
  },
  pauriGarhwal: {
    id: "8",
    value: "Pauri Garhwal",
    label: "Pauri Garhwal",
    hi: "पौड़ी गढ़वाल",
    name: "Pauri Garhwal",
  },
  pithoragarh: {
    id: "9",
    value: "Pithoragarh",
    label: "Pithoragarh",
    hi: "पिथौरागढ़",
    name: "Pithoragarh",
  },
  rudraprayag: {
    id: "10",
    value: "Rudraprayag",
    label: "Rudraprayag",
    hi: "रुद्रप्रयाग",
    name: "Rudraprayag",
  },
  tehriGarhwal: {
    id: "11",
    value: "Tehri Garhwal",
    label: "Tehri Garhwal",
    hi: "टिहरी गढ़वाल",
    name: "Tehri Garhwal",
  },
  udhamSinghNagar: {
    id: "12",
    value: "Udham Singh Nagar",
    label: "Udham Singh Nagar",
    hi: "उधम सिंह नगर",
    name: "Udham Singh Nagar",
  },
  uttarkashi: {
    id: "13",
    value: "Uttarkashi",
    label: "Uttarkashi",
    hi: "उत्तरकाशी",
    name: "Uttarkashi",
  },
};

export const uttarakhandDistrictList = Object.values(uttarakhandDistrictMap);
